async function sendLinks(ob) {
  try {
    const shopDomain = window.Shopify?.shop || window.location.hostname;
    const response = await fetch(
      "https://oddballs-cro-upsell--development.gadget.app/eu-link-tracking",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ob, shopDomain }),
      }
    );
    return response.json();
  } catch (err) {
    console.error("sendLinks error:", err);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const market = document.body.getAttribute("country-url");
  const pageTitle = document.title;
  const fourZeroFourCheck = pageTitle.includes("404");
  const currentUrl = window.location.href;

  const linksArray = [];

  if (market === "/en-eu") {
    // Track EU page links pointing to non-EU URLs
    const links = document.querySelectorAll("a");
    links.forEach((element) => {
      const href = element.href;
      if (
        (href.includes("www.myoddballs.com") && !href.includes("en-eu")) ||
        (href.startsWith("/") && !href.includes("en-eu"))
      ) {
        linksArray.push({ page: currentUrl, link: href, title: pageTitle });
      }
    });
  } else if (fourZeroFourCheck) {
    // Track only UK 404s for non-EU pages
    linksArray.push({ page: currentUrl, link: "UK 404", title: pageTitle });
  }

  // Send collected links if any
  if (linksArray.length > 0) {
    sendLinks(linksArray);
  }
});
